import Icon1 from '../../images/ourmission/icon1.png'
import Icon2 from '../../images/ourmission/icons2.png'
import Icon3 from '../../images/ourmission/icons3.png'


const OurMissionData = [
    {
        icon: Icon1,
        name: "Get it done ",
        description: "Clients trust us to build things that work and we take that seriously. Our team will overcome obstacles, find solutions and deliver exceptional results.",
        delay:"0.2s"
    },
    {
        icon: Icon2,
        name: "Stronger United",
        description: "The positive spirit with which we support each other fosters open, honest, and meaningful relationships. We celebrate and embrace our diversity. We invest in each other because we win or lose as a team.",
        delay:"0.4s"
    }, 

    {
        icon: Icon3,
        name: "Remember the Feeling ",
        description: "Our world can be frustrating, confusing and even scary. We have all been there, so we show empathy and act with humility. We are all human, and therefore, we respect our customers, partners, and co-workers.",
        delay:"0.6s"
    }, 

    

]

export default OurMissionData;